<template lang="pug">
.receive-emergency-transport-patient-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // セル：状態（未確認／確認済）
    template(#cell(confirmed)="row")
      .d-flex.justify-content-center.align-items-center
        ConfirmSwitch(:value="!!row.item.confirmed" @onSwitch="onChangeConfirmed(row.item)")

    // セル：受信日時
    template(#cell(created)="row")
      span {{ formatCreated(row.item.created) }}

    // セル：操作
    template(#cell(operation)="row")
      .d-flex.justify-content-center.align-items-center
        button.btn.detail-btn.mr-2(@click="onDetail(row.item)" type="button") 詳細
        button.btn.print-btn(@click="onPrint(row.item)" type="button") 印刷
</template>

<script lang="ts">
import { EmergencyTransportPatientModel } from "@/commons/services/EmergencyTransportPatients";
import { Component, Prop, Vue } from "vue-property-decorator";
import ConfirmSwitch from "@/pc/basics/ConfirmSwitch.vue";

/**
 * 受信側：救急搬送患者テーブルコンポーネント
 */
@Component({
  components: {
    ConfirmSwitch
  }
})
export default class ReceiveEmergencyTransportPatientTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<ReceiveEmergencyTransportPatientTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<ReceiveEmergencyTransportPatientTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<ReceiveEmergencyTransportPatientTableItem> {
    return this.value;
  }

  /**
   * ### 受信日時のフォーマット
   */
  public formatCreated(created: number): string {
    if (!created) return "";
    return this.$dateUtil.convertNumberToString(created, "yyyy年mm月dd日 hh:MM");
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: ReceiveEmergencyTransportPatientTableItem, filter: FilterSetting): boolean {
    return this.filterSearchWords(row, filter);
  }

  private filterSearchWords(row: ReceiveEmergencyTransportPatientTableItem, filter: FilterSetting): boolean {
    if (!filter || !filter.searchWord || filter.searchWord === "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundFacilityName: boolean = true;
    let foundName: boolean = true;

    for (const word of words) {
      const facilityName = row.facilityName || "";
      if (facilityName.indexOf(word) === -1) {
        foundFacilityName = false;
      }
      if (!row.name || row.name.indexOf(word) === -1) {
        foundName = false;
      }
    }

    return foundFacilityName || foundName;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 確認フラグ変更イベント
   */
  public onChangeConfirmed(patient: ReceiveEmergencyTransportPatientTableItem): void {
    this.$emit("onChangeConfirmed", patient);
    return;
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  public onDetail(patient: ReceiveEmergencyTransportPatientTableItem): void {
    this.$emit("onDetail", patient);
    return;
  }

  /**
   * ### 印刷ボタン押下イベント
   */
  public onPrint(patient: ReceiveEmergencyTransportPatientTableItem): void {
    this.$emit("onPrint", patient);
    return;
  }
}

/** テーブルの列名の情報 */
export interface ReceiveEmergencyTransportPatientTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface ReceiveEmergencyTransportPatientTableItem extends EmergencyTransportPatientModel {}

export interface FilterSetting {
  searchWord: string;
}
</script>

<style lang="scss" scoped>
.receive-emergency-transport-patient-table-component {
  .detail-btn,
  .print-btn {
    width: 64px;
  }
}
</style>
